import { useTranslation } from 'react-i18next'
import { Avatar } from '../Avatar'
import { Badge, MedalBadge } from '../Badge'

export interface Top3RowProps {
  rank: 1 | 2 | 3
  name: string
  score: number
  isMe?: boolean
}

export function Top3Row({ rank, name, score, isMe = false }: Top3RowProps) {
  const { t } = useTranslation()

  return (
    <div className={`top3__row${isMe ? ' top3__row--me' : ''}`}>
      <MedalBadge rank={rank} />
      <Avatar name={name} size={32} />
      <span className="name" style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {name}
      </span>
      {isMe && <Badge variant="me">{t('common.me')}</Badge>}
      <span className="score" style={{ fontVariantNumeric: 'tabular-nums' }}>
        {score}
      </span>
    </div>
  )
}
